import { useLocalStorage } from 'support/react/hooks';
import { Team } from 'types/graphql';

/**
 * Returns the slug of a team that should be used by default.
 *
 * It is either the last visited team, or the first available team in the
 * alphabetical order.
 */
export function useDefaultTeamSlug(availableTeams: Pick<Team, 'slug'>[] = []): string | undefined {
  const orderedSlugs = availableTeams
    .map(team => team.slug)
    .sort((teamA, teamB) => {
      return teamA.toLocaleLowerCase().localeCompare(teamB.toLocaleLowerCase());
    });

  const fallbackSlug = orderedSlugs[0];
  const [storedSlug] = useLocalStorage('team', { initialValue: fallbackSlug });

  return orderedSlugs.includes(storedSlug) ? storedSlug : fallbackSlug;
}
